import { useEffect } from "react";
import {
  APIs,
  API_BASE_URL,
  SERVICEURL,
  SHARED_SERVICEURL,
} from "../constants/Constants";
import axiosInterceptor from "../helpers/Interceptor";
import axios from "axios";
import { isMobile } from "react-device-detect";
import { openHistoryDocViewer } from "../components/HistoryDocViewer/HistoryDocViewer";

export function _base64ToArrayBuffer(base64) {
  var binary_string = window.atob(base64);
  var len = binary_string.length;
  var bytes = new Uint8Array(len);
  for (var i = 0; i < len; i++) {
    bytes[i] = binary_string.charCodeAt(i);
  }
  return bytes.buffer;
}


export const uploadScDicom = async (scImage,imageId) => {
  const formData = new FormData();
  const traceId = Math.random().toString(36).substring(2, 12);
  formData.append('imageId', imageId);
  formData.append('scImage', scImage);
  formData.append('traceId', traceId);
      
  try {
    const response = await axios.post(API_BASE_URL+APIs.SC_DICOM_UPLOAD, formData, {
      headers: {
        'Accept': 'application/json, text/plain, */*'
      },
    });

    console.log('Success:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error:', error.response);
    if (error.response.status === 403) {
      window.location.assign('/logout'); 
    }
    return error.response;
  }
};


export const getStudyCapturedPages = async (studyId) => {
  try {
    const response = await axiosInterceptor.get(
      `${API_BASE_URL}${SERVICEURL}/study/${studyId}/captured-pages`,
    );
    return response.data;
  } catch (error) {
    console.error("Fetch captured pages failed:", error?.response);
    return null;
  }
};


// Effective captured-page layout for EVERY report of the study, keyed by studyReportId.
// The "Images" popup renders reports side-by-side, so each column must come from its own
// report's effective layout instead of a single first-report list applied by position
// (which made a newly added report mirror the first report's captured images).
export const getStudyCapturedPagesByReport = async (studyId) => {
  try {
    const response = await axiosInterceptor.get(
      `${API_BASE_URL}${SERVICEURL}/study/${studyId}/captured-pages/by-report`,
    );
    return response.data;
  } catch (error) {
    console.error("Fetch captured pages by report failed:", error?.response);
    return null;
  }
};


// Persist the "Images" popup state in a single call (decoupled from the report
// save/submit): the captured-image page/layout structure plus the per-study
// "show key image title" and "append captured images at end" flags. `reports` is
// [{ studyReportId, capturedPages: [...] }]; both flags are booleans (omit/null to
// leave unchanged).
export const updateStudyCapturedPages = async (studyId, reports, showKeyImageTitle, appendCapturedImagesAtEnd) => {
  try {
    const response = await axiosInterceptor.post(
      `${API_BASE_URL}${SERVICEURL}/study/${studyId}/captured-pages`,
      { reports, showKeyImageTitle, appendCapturedImagesAtEnd },
      { headers: { "content-type": "application/json" } },
    );
    return response.data;
  } catch (error) {
    console.error("Update captured pages failed:", error?.response);
    return null;
  }
};


export const getStudyKeyImageTitleFlag = async (studyId) => {
  try {
    const response = await axiosInterceptor.get(
      `${API_BASE_URL}${SERVICEURL}/study/${studyId}/key-image-title`,
    );
    return response.data;
  } catch (error) {
    console.error("Fetch key-image-title flag failed:", error?.response);
    return null;
  }
};


export const getScDicomLibrary = async (studyId) => {
  try {
    const response = await axiosInterceptor.get(
      API_BASE_URL + APIs.SC_DICOM_LIBRARY + '/' + studyId
    );
    return response.data;
  } catch (error) {
    console.error('SC DICOM library fetch failed:', error?.response);
    return null;
  }
};


export const submitStudyClipping = async (studyId,seriesId,imageId,scImage) => {
  const formData = new FormData();
  formData.append('studyId', studyId);
  formData.append('seriesId', seriesId);
  formData.append('imageId',imageId);
  if(scImage != null && scImage != undefined){
    formData.append('scImage', scImage);
  }   
  try {
    const response = await axios.post(API_BASE_URL+APIs.SUBMIT_STUDY_CLIPPING, formData, {
      headers: {
        'Accept': 'application/json, text/plain, */*'
      },
    });

    console.log('Success:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error:', error.response);
    if (error.response.status === 403) {
      window.location.assign('/logout'); 
    }
    return error.response;
  }
};


//GET PRIOR STUDY DATA
export const getPriorStudyData = async (studyId, firmId) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.GETPRIORSDATA,
      // API_BASE_URL + SERVICEURL + APIs.GETPATIENTDATA,
      {
        data: {
          parentStudyId: studyId,
          studyId: null,
          firmId: firmId,
        },
      },
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getAdvViewerStatus = async (studyId) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.ADVANCEVIEWERSTATUS,
      {},
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

/**
 * Fetch a single series (with signed image URLs) by studyId + DICOM Series
 * Instance UID. Used after saving a PR/KO annotation to merge in just the new
 * series instead of re-fetching the whole study (see waitForSeriesReady /
 * addSingleSeriesToStudyData in StudyViewerState.jsx).
 */
export const getSeriesByUID = async (studyId, firmId, seriesInstanceUID) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.GETSERIESBYUID,
      {
        data: {
          studyId,
          firmId,
          seriesInstanceUID,
        },
      },
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

// Terminal statuses reported by jwtServices/study/upload/process-status/{processId}
// (see ProgressBar.jsx's studyUploadProcessStatus, which drives the regular
// DICOM-upload progress bar against this same endpoint). "SUTDY_..." typo is the
// backend's actual DONE value — kept verbatim; the correctly-spelled variant is
// included defensively in case that gets fixed later.
const UPLOAD_PROCESS_DONE_STATUSES = ["SUTDY_UPLOAD_PROCESS_DONE", "STUDY_UPLOAD_PROCESS_DONE"];
const UPLOAD_PROCESS_FAILED_STATUSES = [
  "STUDY_UPLOAD_PROCESS_FAILED",
  "STUDY_UPLOAD_PROCESS_FAILED_QUOTA_OVER",
  "STUDY_UPLOAD_PROCESS_INVALID_DICOM",
  "STUDY_UPLOAD_PROCESS_DCM_PROCESS_FAILED",
  "STUDY_UPLOAD_PROCESS_ID_NOT_FOUND",
];

/**
 * Poll jwtServices/study/upload/process-status/{processId} until the async DICOM
 * ingestion for a save-pr/save-ko (or regular upload) finishes, instead of a flat
 * timed wait. Resolves (never rejects) with { success, status, message } —
 * success:false on a terminal failure status OR on timeout.
 */
export const waitForUploadProcessDone = (
  processId,
  { intervalMs = 1000, timeoutMs = 30000 } = {}
) => {
  return new Promise((resolve) => {
    const startedAt = Date.now();

    const poll = async () => {
      try {
        const res = await axiosInterceptor.post(
          API_BASE_URL + SERVICEURL + APIs.FETCHUPLOADPROCESSSTATUS + processId,
          {}
        );
        const status = res?.data?.data?.status;
        const message = res?.data?.data?.message;

        if (UPLOAD_PROCESS_DONE_STATUSES.includes(status)) {
          resolve({ success: true, status, message });
          return;
        }
        if (UPLOAD_PROCESS_FAILED_STATUSES.includes(status)) {
          resolve({ success: false, status, message });
          return;
        }
      } catch (_err) {
        // Transient network/server error — keep polling until timeout below.
      }

      if (Date.now() - startedAt >= timeoutMs) {
        resolve({
          success: false,
          status: "TIMEOUT",
          message: "Timed out waiting for processing to complete",
        });
        return;
      }
      setTimeout(poll, intervalMs);
    };

    poll();
  });
};

//GET STUDY DAYA
export const getStudyData = async (
  studyId,
  firmId,
  hybridMode,
  advanceViewer
) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.GETSTUDYDATA,
      // API_BASE_URL + SERVICEURL + APIs.GETPATIENTDATA,
      {
        data: {
          studyId,
          firmId,
          hybridMode,
          advanceViewer,
          // Signals the backend to build the advance viewer token with the mobile profile
          isMobile,
        },
      },
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

// open-api for studyviewer direct access
export const getStudyDataForContextSwitch = async () => {
  try {
       // Get a specific query parameter
       const queryString = window.location.search;
       const urlParams = new URLSearchParams(queryString);
       const clientId = urlParams.get('clientId');
       const secretKey = urlParams.get('secretKey');
       const studyId = urlParams.get('studyId');
      
       const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.GETOPENAPISTUDYDATA,
      // API_BASE_URL + SERVICEURL + APIs.GETPATIENTDATA,
      {
        data: {
          clientId: clientId,
          studyId: studyId,
          secretKey: secretKey
        
        },
      },
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

//GET STUDY DAYA
export const getMobileStudyData = async (
  studyId,
  firmId,
  hybridMode,
  advanceViewer
) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.GETMOBILESTUDYDATA,
      // API_BASE_URL + SERVICEURL + APIs.GETPATIENTDATA,
      {
        data: {
          studyId,
          firmId,
          hybridMode,
          advanceViewer,
        },
      },
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

//GET STUDY DAYA
export const getSharedStudyData = async (token, isActiveData, switchViewer, openViewer) => {

  try {
    const response = await axios.post(
      API_BASE_URL + SHARED_SERVICEURL + APIs.GETSHAREDSTUDYDATA,
      // API_BASE_URL + SERVICEURL + APIs.GETPATIENTDATA,
      {
        data: {
          token,
          isActiveData,
          switchViewer,
          openViewer
        },
      },
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

/**
 * The shared study plus the priors its link offers, for the basic viewer.
 *
 * Plain axios, like the other share-link reads: a visitor has no session, so the
 * interceptor's 403-then-refresh-then-retry would be two wasted round trips. It also
 * must not redirect to logout on failure -- there is nothing to log out of, and the
 * caller falls back to opening the study by itself.
 */
export const getSharedStudyPriorsData = async (token, isActiveData) => {
  try {
    return await axios.post(
      API_BASE_URL + SHARED_SERVICEURL + APIs.GETSHAREDSTUDYPRIORSDATA,
      { data: { token, isActiveData } },
      { headers: { "content-type": "application/json" } }
    );
  } catch (error) {
    return error.response;
  }
};

//GET ADVANCE VIEWER URL
export const getAdvanceViewerUrl = async(token, isActiveData) => {
  try {
    const response = await axios.post(
      API_BASE_URL + SHARED_SERVICEURL + APIs.GETSHAREDSTUDYADVACNEVIEWERURL,
      {
        data: {
          token,
          isActiveData
        },
      },
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

// 1) Check if password is required/bypass allowed
export const isSharePasswordBypassAllowed = async (token, isActiveData) => {
  try {
    const response = await axios.post(
      API_BASE_URL + SHARED_SERVICEURL + APIs.GETSHAREDSTUDYBYPASS, // e.g. "/study/share/password/allowed"
      {
        data: {
          token,
          isActiveData,
        },
      },
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );
    return response; // server .data should be a boolean
  } catch (error) {
    if (error?.response?.status === 403) {
      window.location.assign(APIs.REDIRECTLOGOUT);
    } else {
      return error.response || {
        status: 500,
        data: { result: "FAILURE", message: error.message },
      };
    }
  }
};

// 2) Validate user-entered password
export const validateSharePassword = async (token, password, isActiveData) => {
  try {
    const response = await axios.post(
      API_BASE_URL + SHARED_SERVICEURL + APIs.VALIDATESHAREDSTUDYPASSWORD, // e.g. "/study/share/password/validate"
      {
        data: {
          token,
          password,
          isActiveData,
        },
      },
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );
    return response; // server .data should be a boolean
  } catch (error) {
    if (error?.response?.status === 403) {
      window.location.assign(APIs.REDIRECTLOGOUT);
    } else {
      return error.response || {
        status: 500,
        data: { result: "FAILURE", message: error.message },
      };
    }
  }
};

//DOWNLOAD STUDY
export const downloadStudyZip = async (studyId) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.DOWNLOADSTUDYZIP,
      {
        data: {
          studyId,
        },
      },
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

//START DOWNLOADING ZIP FILE
export const startDownloadingZip = async (studyId) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.STARTDOWNLOADSTUDYZIP,
      {
        data: {
          studyId,
        },
      },
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

//FETCH PROGRESS OF DOWNLOAD
export const fetchDownloadProgress = async (token) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.FETCHDOWNLOADPROGRESS,
      {
        data: {
          token,
        },
      },
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

//DOWNLOAD COMPLETED FILE
// URL the browser can download a finished study zip / PPT from by itself (session cookie auth)
export const getCompletedFileUrl = (token) =>
  API_BASE_URL + SERVICEURL + APIs.DOWNLOADCOMPLETEDFILE + "/" + encodeURIComponent(token);

// onProgress(loaded, total) is called as the file arrives; total is 0 if the size is unknown
export const downloadCompletedFile = async (token, onProgress) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.DOWNLOADCOMPLETEDFILE,
      {
        data: {
          token,
        },
      },
      {
        responseType: "arraybuffer",
        onDownloadProgress: (event) =>
          onProgress && onProgress(event.loaded, event.total || 0),
      },
      {
        headers: {
          "content-type": "application/json",
          Accept: "*/*",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

//DOWNLOAD PPT
export const downloadStudyPPT = async (studyId, stackId) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.DOWNLOADSTUDYPPT,
      {
        data: {
          studyId,
          seriesNumber: stackId,
        },
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

//DOWNLOAD PPT
export const startDownloadingPpt = async (studyId, stackId) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.DOWNLOADSTUDYPPTASYNC,
      {
        data: {
          studyId,
          seriesNumber: stackId,
        },
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const historyDownload = async (body, extension) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.HISTORYDOWNLOAD,
      {
        data: body,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    if (response.status === 200) {
      // Uploaded files are untrusted: never open them as a document on our origin (blob: tab,
      // document.write). doc/docx are downloaded; everything else goes to the in-app viewer
      // (VAPT: stored XSS via history upload).
      const ext = (extension || "").toLowerCase();
      const { data: base64, filename } = response.data.data;
      const bytes = new Uint8Array(_base64ToArrayBuffer(base64));
      if (ext === "doc" || ext === "docx") {
        const url = window.URL.createObjectURL(new Blob([bytes], { type: "application/octet-stream" }));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
        setTimeout(() => window.URL.revokeObjectURL(url), 1000);
      } else {
        openHistoryDocViewer({ filename, extension: ext, bytes });
      }
    }
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else {
      // 422: the backend refused to serve the file (PDF with scripts / embedded content)
      if (error.response?.status === 422) {
        openHistoryDocViewer({ error: error.response.data?.message || "This file was blocked." });
      }
      return error.response;
    }
  }
};

export const ReturnStudyApi = async (body, blitzSession) => {
  console.log("payload", body);
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + "/study/unassignStudy",
      {
        data: {
          unassignStudy: body,
          blitzSession: blitzSession
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const ReleaseStudyApi = async (studyId) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + "/study/releaseStudy",
      {
        data: {
          studyId: studyId,
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const ReleasePreliminaryStudyApi = async (studyId, readyForReview = false) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + "/study/releasePreliminaryStudy",
      {
        data: {
          studyId: studyId,
          readyForReview: !!readyForReview,
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response?.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const logViewOriginalImage = async (studyId) => {
  try {
    await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.LOGVIEWORIGINAL,
      {
        data: {
          studyId,
        },
      }
    );
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const activeRadiologistViewing = async (studyId, active) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.ACTIVERADIOLOGISTVIEWING,
      {
        data: {
          studyId: studyId,
          isRadActive: active,
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getAdvKeyImagesAPI = async (studyId) => {
  try {
    const response = await axiosInterceptor.get(
      API_BASE_URL + SERVICEURL + `/study/${studyId}/advviewer/keyimages`,
      {}
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const updateAdvKeyImagesAPI = async (studyId, advKeyImageList) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + `/study/${studyId}/advviewer/keyimages`,
      {
        data: {
          keyImages: advKeyImageList,
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const _getAdvKeyImageForPreview = async (studyId, imageId) => {
  try {
    const response = await axiosInterceptor.get(
      API_BASE_URL +
        SERVICEURL +
        `/study/${studyId}/advviewer/keyimages/${imageId}/rendered`,
      {}
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getStudyExpirationStatus = async (studyId) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + `/unassignment/study/expiration/status/${studyId}`,
      {}
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const extendStudyExpiration = async (studyId) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + `/unassignment/study/extend/expiration/${studyId}`,
      {}
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
}

export const forceReinferenceImage = async (studyId, imageId) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + "/image/retriage",
      { data: { studyId, imageId } }
    );
    return response;
  } catch (error) {
    return error.response;
  }
};
